// import { updateData } from 'data/api'
import { ExistingTweetToAdd, TweetReplyToCreateInternal } from 'data/twitter/types'
import useSWR, { KeyedMutator } from 'swr'
import { post } from 'utilities/api'
import { getBlotterUrlFromHostAndPath, getPathFromUrl } from 'utilities/url'
import { Conversation } from './types'

let mutateConversationsFn: KeyedMutator<{ conversations: Conversation[] }>

export const useConversationsByHostAndUrl = (hostId?: string, url?: string) => {
  const urlPath = url ? getPathFromUrl(url) : undefined
  return useConversationsByHostAndPath(hostId, urlPath)
}

export const useConversationsByHostAndPath = (hostId?: string, urlPath?: string) => {
  const blotterId = hostId && urlPath
    ? getBlotterUrlFromHostAndPath(hostId, urlPath)
    : ''
  const { data, error, mutate: mutateConversations } = useSWR<{ conversations: Conversation[]}>(blotterId ? `/conversations/byurl/${blotterId}` : null)

  mutateConversationsFn = mutateConversations

  return {
    conversations: data?.conversations,
    isConversationLoading: !error && !data,
    isConversationError: error,
    mutateConversations,
  }
}

export const useConversationById = (conversationId?: string) => {
  // console.log('useConversationById', conversationId)
  const { data: conversation, error, mutate } = useSWR<{ conversations: Conversation[]}>(conversationId ? `/conversations/${conversationId}` : null)
  // console.log({ data })

  return {
    conversation: conversation,
    isConversationLoading: !error && !conversation,
    isConversationError: error,
    mutateConversation: mutate,
  }
}

export const createCommentForConversation = async ({ replyToBlotterId, text }: TweetReplyToCreateInternal) => {
  console.log('Create Comment For Conversation', replyToBlotterId)
  const createdComment = await post(`/conversations/${replyToBlotterId}/comments`, { text, replyToBlotterId })
  return createdComment?.data
}

export const addExistingConversation = async ({ blogPostId, externalId }: ExistingTweetToAdd) => {
  const result = await post('/conversations/existing', { blogPostId, externalId })
  return result?.data
}

export const updateConversations = () => {
  console.log('update conversations')
  if (mutateConversationsFn) {
    mutateConversationsFn()
  } else {
    throw new Error('Conversations Update Error')
  }
}
